<template>
	<div class="operate-form">
		<table-pagination ref="tableItem" :data="tableData" :column="column.column" @row-click="handleCurrentChange">
			<template v-slot:workdaySubType="{row}">
				<div class="operate-inline">
					<el-cascader size="mini" :show-all-levels="false"  :options="options" 
					:props="props" collapse-tags clearable v-model="row.workdaySubType" 
					 @change="(val)=>csacaderScopeChange(val,row)"
					v-if="tabChoseIndex == row.priority"></el-cascader>
					<span v-else>{{formatVal(row.workdaySubType)}}</span>
				</div>
			</template>
			<template v-slot:date="{row}">
				<el-date-picker 
					v-if="tabChoseIndex == row.priority"  
					type="datetimerange" 
					v-model="row.date"  
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					size="mini"
					format="yyyy/MM/dd HH:mm:ss" 
					value-format="timestamp" clearable  
					unlink-panels style="width: 100%;">
				</el-date-picker>
				<span v-else>{{row.date ? `${$dayjs(row.date[0]).format('YYYY/MM/DD HH:mm:ss')}至${$dayjs(row.date[1]).format('YYYY/MM/DD HH:mm:ss')}`:'--'}}</span>
			</template>
			<template v-slot:time="{row}">
				<el-time-picker is-range size="mini"
					style="width: 100%;"
					value-format="timestamp"
					format="HH:mm"
				   v-model="row.time"
				   range-separator="至"
				   start-placeholder="开始时间"
				   end-placeholder="结束时间"
				   placeholder="选择时间范围" v-if="tabChoseIndex == row.priority">
				 </el-time-picker>
				<span v-else>{{row.time ? `${$dayjs(row.time[0]).format('HH:mm')}至${$dayjs(row.time[1]).format('HH:mm')}`:'--'}}</span>
			</template>
			<template v-slot:remark="{row}">
				<el-input maxlength="20" show-word-limit placeholder="请输入内容" v-model="row.remark" clearable
					 v-if="tabChoseIndex == row.priority"></el-input>
				<span v-else>{{row.remark}}</span>
			</template>
			<template v-slot:msgId="{row}">
				<el-select v-model="row.msgId" clearable placeholder="请选择" filterable 
					v-if="tabChoseIndex == row.priority">
					<el-option v-for="item in msgList.list" :key="item.id" :label="item.holidayMsg"
						:value="item.id"><span v-html="item.holidayMsg"></span>
					</el-option>
				</el-select>
				<span v-else>{{row.msgId}}</span>
			</template>
			<template v-slot:action="{row,$index}">
				<el-button type="text" size="small" @click.stop="onDelete(row, $index)">删除</el-button>
				<!-- <el-divider direction="vertical"></el-divider>
				<el-button type="text" size="small" icon="el-icon-top" circle @click.stop="onUp($index)">
				</el-button>
				<el-divider direction="vertical"></el-divider>
				<el-button type="text" size="small" icon="el-icon-bottom" circle @click.stop="onDown($index)">
				</el-button> -->
			</template>
		</table-pagination>
		<el-button size="mini" type="primary" plain icon="el-icon-plus" style="margin-top: 17px;" @click="onAdd">添加时间策略</el-button>
	</div>
</template>

<script>
	import {day_data,cascader_week} from '../data.js'
	export default {
		props:['column','data'],
		inject: ['msgList'],
		// computed:{
		// 	tableData(){
		// 		return this.data.tableData
		// 	}
		// },
		mounted() {
			this.tableData = JSON.parse(JSON.stringify(this.data))
			this.$emit("updateData",{
				type:this.column.type,
				tableData:this.tableData
			})
		},
		watch:{
			'data':{
				handler(val){
					this.tableData = val
					this.$emit("updateData",{
						type:this.column.type,
						tableData:val
					})
				},
				deep:true
			},
		},
		data() {
			return {
				options:cascader_week,
				shareScopeEnd:[],
				props:{
					 multiple:true,
				},
				tabChoseIndex:0	,
				tableData:[],
			}
		},
		methods:{
			csacaderScopeChange(val,row){
				let changeFlag=false;
			   let  changeItem=null;
				if(this.shareScopeEnd.length===0){
					row.workdaySubType = val;
				}
				else{
					//与原数组比对
					row.workdaySubType.forEach((item)=>{
					//与原数组的类型相同
						if(item[0]!==this.shareScopeEnd[0][0]){
							changeFlag = true;
							changeItem=item;
						}
					});
				}
				if(changeFlag){
				  //上次是system,那么这次是domain
					if(this.shareScopeEnd[0][0]==='8'){
						row.workdaySubType =row.workdaySubType.filter((item)=>{
							 return (item[0]!== '8');
						  });
					}else{
						row.workdaySubType=[];
						row.workdaySubType.push(changeItem);
					}
				}
				this.shareScopeEnd = row.workdaySubType;

			},
			handleCurrentChange(row) {
				this.tabChoseIndex = row.priority;
			},
			onAdd(){
				const keyIndex = this.tableData.length ? (this.tableData[this.tableData.length - 1]['priority'] + 1) : 1;
				let obj = JSON.parse(JSON.stringify(this.column.add_obj));
				obj.priority = keyIndex
				if(this.tableData.length != 0) {
					if (this.tableData.every(el => Object.keys(el).every(i => el[i]))){
						this.tableData.push(obj);
						this.tabChoseIndex = keyIndex;
					}else{
						this.$message.error('内容不能为空')
					}
					
				}else{
					this.tableData.push(obj);
					this.tabChoseIndex = keyIndex;
				}
				
			},
			onDelete(row, index){
				if (row.priority == this.tabChoseIndex) {
					if (this.tableData.length > 1) {
						this.tabChoseIndex = this.tableData[this.tableData.length - 2]['priority'];
					}
				}
				this.tableData.splice(index, 1);
			},
			onUp(index){
				if (index > 0) {
					let upData = this.tableData[index - 1]
					this.tableData.splice(index - 1, 1)
					this.tableData.splice(index, 0, upData)
				} else {
					this.$message.warning('处于最优先级，不能继续上移')
				}
			},
			onDown(index){
				if ((index + 1) == this.tableData.length) {
					this.$message.warning('已是最后一条，不可下移')
				} else {
					let downData = this.tableData[index + 1]
					this.tableData.splice(index + 1, 1)
					this.tableData.splice(index, 0, downData)
				}
			},
			//级联显示中文
			formatVal(key){
				let result = []
				if(key){
					if(this.isArray(key)){
						key = key.flat()
					}
					else {
						key = key.split(",")
					}
					key.map(item => {
						if(day_data.filter(el => el.value == item).length > 0){
							 result.push(day_data.filter(el => el.value == item)[0].label)
						}
					})
					return result.join(',')
					 
				 }
				 return '--'
			},
			 isArray(something){
			    return Object.prototype.toString.call(something) === '[object Array]';
			}
		}
	}
</script>

<style lang="scss">
	.operate-form {
		margin-top: 10px;
		.el-table__empty-block {
			display: none;
		}
		
	}
</style>
